import React from 'react';
import { Alert, Box } from '@spothero/ui';
import dayjs from 'utils/dayjs';
const START_DATE_RESTRICTIONS = {
    '1st_only': '1st',
    '1st_or_15th': '1st or 15th',
};
const MonthlyStartCallout = ({ monthlyStarts, rateStartDate, amenities, startDateRestrictions, showIcon = true, containerStyles = {}, }) => {
    const isInstantParking = amenities.some(a => a.slug === 'immediate-parking' || a.slug === 'immediate_parking');
    const monthlyStartsDayjs = dayjs(monthlyStarts);
    const dateDifference = monthlyStartsDayjs.diff(rateStartDate, 'day');
    const showAlert = (!isInstantParking && dateDifference > 0) ||
        (isInstantParking && dateDifference >= 7);
    if (!showAlert || !START_DATE_RESTRICTIONS[startDateRestrictions]) {
        return null;
    }
    return (<Box color="black" data-testid="monthly-start-callout" {...containerStyles}>
            <Alert margin={{ base: '4', desktop: 'auto' }} description={`Monthly parking is not prorated. Your start date will align with the location’s billing cycle, starting on the ${START_DATE_RESTRICTIONS[startDateRestrictions]}.`} status="warning" showIcon={showIcon}/>
        </Box>);
};
export default MonthlyStartCallout;
